module.exports = __webpack_public_path__ + "static/media/g1.8258703a.svg";